import React from 'react';
import { Button, Affix } from 'antd';
import { FaPlus } from 'react-icons/fa';
import { History } from 'history';
import { useHistory } from 'react-router-dom';

export const AddMealButton: React.FC = () => {
  const history: History = useHistory();

  const handleButtonClick = () => {
    history.push('mymeals/create');
  };

  return (
    <Affix offsetBottom={20}>
      <div className="floating-button">
        <Button shape="circle" size="large" onClick={handleButtonClick}>
          <FaPlus size={14} />
        </Button>
      </div>
    </Affix>
  );
};
